module.exports = __webpack_public_path__ + "img/glassquality_2.3108ce03.png";